import openingsDataRaw from './openings.json';
import openingsLargeRaw from './openings-large.json';
// Asegurarse de mantener el tipo correcto para la lectura de JSON
const openingsGroups = (openingsDataRaw.default || openingsDataRaw);
const openingsLarge = (openingsLargeRaw.default || openingsLargeRaw);
export function detectOpening(history) {
    if (!history || history.length === 0)
        return null;
    // Normalizar historial a minúsculas
    const cleanHistory = history.map(m => (m || '').toLowerCase());
    const initialOpenings = [
        { name: 'Apertura de Peón de Rey', tag: 'kp', moves: ['e2e4'], steps: [{ comment: 'El blanco toma el centro y libera diagonales.' }] },
        { name: 'Defensa Siciliana', tag: 'sicilian', moves: ['e2e4', 'c7c5'], steps: [{ comment: '' }, { comment: 'La respuesta más combativa contra e4.' }] },
        { name: 'Defensa Francesa', tag: 'french', moves: ['e2e4', 'e7e6'], steps: [{ comment: '' }, { comment: 'Una defensa sólida que prepara d5.' }] },
        { name: 'Defensa Caro-Kann', tag: 'caro', moves: ['e2e4', 'c7c6'], steps: [{ comment: '' }, { comment: 'La defensa de hierro, buscando solidez extrema.' }] },
        { name: 'Apertura de Peón de Dama', tag: 'qp', moves: ['d2d4'], steps: [{ comment: 'Posición sólida que controla el centro.' }] },
        { name: 'Gambito de Dama', tag: 'qg', moves: ['d2d4', 'd7d5', 'c2c4'], steps: [{ comment: '' }, { comment: '' }, { comment: 'El blanco ofrece un peón para dominar el centro.' }] },
        { name: 'Apertura Inglesa', tag: 'english', moves: ['c2c4'], steps: [{ comment: 'Control central desde el flanco.' }] },
        { name: 'Apertura Réti', tag: 'reti', moves: ['g1f3'], steps: [{ comment: 'Desarrollo flexible.' }] }
    ];
    let bestMatch = null;
    let maxDepth = 0;
    let bestIsFullMatch = false;
    const checkOpening = (opening, groupName) => {
        if (!opening || !opening.moves || opening.moves.length === 0)
            return;
        let matchedCount = 0;
        const opMoves = opening.moves.map((m) => m.toLowerCase());
        for (let i = 0; i < opMoves.length && i < cleanHistory.length; i++) {
            if (opMoves[i] === cleanHistory[i]) {
                matchedCount++;
            }
            else {
                return; // No coincide esta línea
            }
        }
        if (matchedCount === 0)
            return;
        const isFullMatch = matchedCount === opMoves.length;
        // Criterio de mejor match
        if (matchedCount > maxDepth) {
            maxDepth = matchedCount;
            bestIsFullMatch = isFullMatch;
            updateBest(opening, groupName, matchedCount);
        }
        else if (matchedCount === maxDepth && isFullMatch && !bestIsFullMatch) {
            bestIsFullMatch = true;
            updateBest(opening, groupName, matchedCount);
        }
        // Revisar variantes siempre que haya algún match inicial
        if (opening.variants && matchedCount > 0) {
            for (const v of opening.variants) {
                checkOpening(v, groupName);
            }
        }
    };
    const updateBest = (opening, groupName, count) => {
        const comment = opening.steps?.[count - 1]?.comment ||
            (count === opening.moves?.length ? opening.description : undefined);
        bestMatch = {
            groupName,
            name: opening.name,
            moves: opening.moves || [],
            commentary: comment
        };
    };
    // 1. Revisar aperturas iniciales (hardcoded para velocidad)
    for (const op of initialOpenings)
        checkOpening(op, 'Principales');
    // 2. Revisar base de datos JSON principal (con comentarios)
    if (Array.isArray(openingsGroups)) {
        for (const g of openingsGroups) {
            if (g && g.items) {
                for (const it of g.items)
                    checkOpening(it, g.group);
            }
        }
    }
    // 3. Revisar base de datos extendida (Lichess/ECO)
    if (Array.isArray(openingsLarge)) {
        for (const op of openingsLarge) {
            checkOpening(op, `Apertura ${op.eco}`);
        }
    }
    return bestMatch;
}
